import React from 'react';
import { Route, Switch, useLocation, useRouteMatch, Redirect } from 'react-router-dom';
import styled from 'styled-components/macro';
import { observer } from 'mobx-react';
import { AnimatePresence } from "framer-motion";

import { useDataStore } from 'state/DataStore';
import getRouteKey from 'utilities/getRouteKey';

import PageContainer from 'components/PageContainer';
import PageTemplate from 'templates/PageTemplate';
import SubpageRouter from './SubpageRouter';

const Body = observer(() => {
    const dataStore = useDataStore();
    const location = useLocation();
    const match = useRouteMatch();
    
    const { appPages } = dataStore;
    const hasHome = appPages.some((p) => p.slug === 'home');
    const firstBasePage = appPages.find((p) => p.slug !== 'home');
    
    return (
        <BodyContainer>
            <PageContainer>
                <AnimatePresence>
                    <Switch location={location} key={getRouteKey(location, match)}>
                        {!hasHome && firstBasePage && (
                            <Route exact path="/">
                                <Redirect to={`/${firstBasePage.slug}`}/>
                            </Route>
                        )}
                        {appPages.map((page) => {
                            const isHome = (page.slug === 'home');
                            const path = isHome ? '/' : `/${page.slug}`;
                            
                            if (page.children) {
                                // Render nested routes for pages with children
                                return (
                                    <Route key={page.slug} path={path}>
                                        <SubpageRouter page={page} />
                                    </Route>
                                );
                            } else {
                                // Render regular page template for pages without children
                                return (
                                    <Route key={page.slug} path={path} exact={isHome}>
                                        <PageTemplate page={page}/>
                                    </Route>
                                );
                            }
                        })}
                    </Switch>
                </AnimatePresence>
            </PageContainer>
        </BodyContainer>
    );
});


export default Body;


const BodyContainer = styled.div`
	position: relative;
    z-index: 1;
	width: 100%;
	flex: 1 0 auto;
`;
